import {
  SHOW_CONTACT_DETAILS,
  SHOW_CHAT_HEADS,
  SHOW_MESSAGES,
} from '../constant';

export const showContactDetails = () => {
  return { type: SHOW_CONTACT_DETAILS };
};

export const showMessages = () => {
  return { type: SHOW_MESSAGES };
};

export const showChatHeads = () => {
  return { type: SHOW_CHAT_HEADS };
};
